import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import VideoRow from '../components/VideoRow';
import PlayerModal from '../components/PlayerModal';

// OTT-Style Premium Sections
import OriginalsRow from '../components/home/OriginalsRow';
import ModuleRow from '../components/home/ModuleRow';
import GenrePills from '../components/home/GenrePills';
import PremiumAccess from '../components/home/PremiumAccess';

import { useStore } from '../context/StoreContext';

const Home = () => {
  const [activeVideo, setActiveVideo] = useState(null);
  const { videos, user } = useStore();

  const publishedVideos = videos.filter(v => v.status === 'published');

  // Specific Rows logic
  const continueLearning = publishedVideos.filter(v => v.progress > 0);
  const trendingNow = publishedVideos.filter(v => v.category === 'Trending Now');
  const basics = publishedVideos.filter(v => v.category === 'Basics of RocketAlgo');

  // Collect other categories dynamically
  const specialCategories = ['Trending Now', 'Basics of RocketAlgo'];
  const otherCategories = [...new Set(publishedVideos.map(v => v.category))]
    .filter(c => !specialCategories.includes(c) && c !== 'Continue Learning');

  const handleSubscribe = () => {
    window.open('https://pages.razorpay.com/rcktalgonewplan', '_blank');
  };

  // Mock Data for "Trending in Trader Education" to perfectly match the requested design aesthetics
  const trendingEducation = [
    { id: 't1', title: 'Candlestick Basics', duration: '14m', tags: ['Beginner', 'HD'], thumbnailUrl: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&q=80&w=600', accessLevel: 'free', status: 'published' },
    { id: 't2', title: 'Support & Resistance', duration: '22m', tags: ['Setup', 'Pro'], thumbnailUrl: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&q=80&w=600', accessLevel: 'pro', status: 'published' },
    { id: 't3', title: 'Supply & Demand Zones', duration: '19m', tags: ['Advanced', 'HD'], thumbnailUrl: 'https://images.unsplash.com/photo-1642543492481-44e81e391452?auto=format&fit=crop&q=80&w=600', accessLevel: 'pro', status: 'published' },
    { id: 't4', title: 'Option Chain Decoded', duration: '35m', tags: ['Options', 'Pro'], thumbnailUrl: 'https://images.unsplash.com/photo-1535320903710-d9938a44917a?auto=format&fit=crop&q=80&w=600', accessLevel: 'pro', status: 'published' },
    { id: 't5', title: 'What is HFT', duration: '12m', tags: ['Theory', 'HD'], thumbnailUrl: 'https://images.unsplash.com/photo-1605792657660-596af9009e82?auto=format&fit=crop&q=80&w=600', accessLevel: 'free', status: 'published' },
    { id: 't6', title: 'Multiple Timeframe Analysis', duration: '28m', tags: ['Strategy', 'Pro'], thumbnailUrl: 'https://images.unsplash.com/photo-1516245834210-c4c142718d21?auto=format&fit=crop&q=80&w=600', accessLevel: 'pro', status: 'published' }
  ];

  return (
    <div className="min-h-screen bg-dark-bg flex flex-col font-sans overflow-x-hidden">
      <Navbar />
      
      <Hero />

      {/* 
        FIXED OVERLAP: 
        Reduced negative margin (-mt-12 md:-mt-20) to pull the gradient background up smoothly, 
        and added larger padding-top (pt-20 md:pt-32) to push the actual text and rows down safely 
        away from the Hero buttons.
      */}
      <div className="relative z-20 -mt-12 md:-mt-20 pt-20 md:pt-32 pb-16 w-full bg-gradient-to-b from-transparent via-dark-bg to-dark-bg">
        
        {/* OTT Row: Trending Now */}
        {trendingNow.length > 0 && (
          <VideoRow title="Trending Now" videos={trendingNow} onPlay={(video) => setActiveVideo(video)} seeAllLink="/courses" />
        )}

        {/* OTT Row: Continue Learning */}
        {user.isLoggedIn && continueLearning.length > 0 && (
          <VideoRow title={`Continue Learning for ${user.name || 'Trader'}`} videos={continueLearning} onPlay={(video) => setActiveVideo(video)} />
        )}

        {/* Netflix Original Style Feature Row */}
        <OriginalsRow />

        {/* Series/Module Style Row */}
        <ModuleRow />

        {/* Dynamic Database Row: Basics */}
        {basics.length > 0 && (
          <VideoRow title="Basics of RocketAlgo" videos={basics} onPlay={(video) => setActiveVideo(video)} seeAllLink="/basics" />
        )}

        {/* Specific Requested OTT Row: Trending in Trader Education */}
        <VideoRow title="Trending in Trader Education" videos={trendingEducation} onPlay={(video) => setActiveVideo(video)} />

        {/* Other Dynamic Database Categories */}
        {otherCategories.map(category => {
          const categoryVideos = publishedVideos.filter(v => v.category === category);
          if (categoryVideos.length === 0) return null;
          return (
            <VideoRow key={category} title={category} videos={categoryVideos} onPlay={(video) => setActiveVideo(video)} seeAllLink="/courses" />
          );
        })}

        {/* Netflix-style Genre/Topic exploration */}
        <GenrePills />
      </div>

      {/* Elegant Premium Membership positioning instead of aggressive CTA */}
      {!user.isSubscribed && (
        <PremiumAccess onSubscribe={handleSubscribe} />
      )}

      <PlayerModal isOpen={!!activeVideo} onClose={() => setActiveVideo(null)} video={activeVideo} />
    </div>
  );
};

export default Home;